/**
 * Sync product gradient colors to Judge.me widget
 * Since Judge.me app blocks are rendered outside the product section,
 * we need to manually apply the gradient colors via JavaScript
 */

(function() {
  'use strict';
  
  function syncGradientColors() {
    // Find the product section that has the gradient color variables
    const productSection = document.querySelector('.section__m-product');
    if (!productSection) return;
    
    // Get the CSS variables from the product section
    const styles = getComputedStyle(productSection);
    const color1 = styles.getPropertyValue('--product-gradient-color-1').trim();
    const color2 = styles.getPropertyValue('--product-gradient-color-2').trim();
    
    // Only proceed if we have both colors
    if (!color1 || !color2) return;
    
    // Find the Judge.me widget
    const judgemeWidget = document.querySelector('#judgeme_product_reviews');
    if (!judgemeWidget) return;
    
    // Apply the CSS variables to the Judge.me widget
    judgemeWidget.style.setProperty('--product-gradient-color-1', color1);
    judgemeWidget.style.setProperty('--product-gradient-color-2', color2);
    
    console.log('Judge.me gradient colors synced:', color1, color2);
  }
  
  // Run on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncGradientColors);
  } else {
    syncGradientColors();
  }
  
  // Also run after a short delay to catch dynamically loaded content
  setTimeout(syncGradientColors, 500);
  setTimeout(syncGradientColors, 1500);
  
  // Watch for Judge.me widget being added to DOM
  const observer = new MutationObserver(function(mutations) {
    for (let mutation of mutations) {
      if (mutation.addedNodes.length) {
        for (let node of mutation.addedNodes) {
          if (node.nodeType === 1) { // Element node
            if (node.id === 'judgeme_product_reviews' || 
                node.querySelector('#judgeme_product_reviews')) {
              syncGradientColors();
              break;
            }
          }
        }
      }
    }
  });
  
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
  
})();
